var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    _vm.border ? 'border' : '',
    'page-heading flex space-between align-center'
  ]},[_c('div',{staticClass:"flex align-center"},[(_vm.back)?_c('span',{staticClass:"go-back mdi mdi-24px mdi-chevron-left cursor-pointer",on:{"click":_vm.goBack}}):_vm._e(),_c('Heading',{attrs:{"heading":_vm.title}})],1),_c('div',{staticClass:"right-aligned-items"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }